.itemsToBeReorderedContainer {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.itemToBeReordered {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.itemToBeReorderedText {
    margin-left: 20px;
}